
<!-- Modal moneda -->
<div
    class="modal fade"
    id="app-modal-currencies"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelTitleId"
    aria-hidden="true"
    >
    <div
        class="modal-dialog modal-dialog-centered"
        role="document"
        >
        <div
            class="modal-content rounded"
            [ngClass]="{'bg-dark white-text': (ls.isDarkmode),
                        'bg-primary-dark': (ls.isDarkmode),
                        'bg-primary-light': (!ls.isDarkmode)}"
            >
            <app-header-title
                title="currency_section.currency_choose"
                modalId="app-modal-currencies"
                >
            </app-header-title>
            <div class="modal-body">
                <div class="container scrollable">
                    <div class="row text-center">
                        <div
                          class="col-6"
                          [ngClass]="{'bg-dark': ls.isDarkmode, 'bg-light': !ls.isDarkmode}">
                          {{ "currency_section.currency_iso_code" | translate }}
                        </div>
                        <div
                          class="col-6"
                          [ngClass]="{'bg-dark': ls.isDarkmode, 'bg-light': !ls.isDarkmode}">
                          {{ "currency_section.currency_symbol" | translate }}
                        </div>
                    </div>
                    <div
                      *ngFor="let currency of currencies"
                      [id]="currency.isoCode"
                      [ngClass]="{'bg-dark': ls.isDarkmode, 'bg-light': !ls.isDarkmode}"
                      class="row text-center pb-2 pt-2 pointer cell"
                      (click)="setCurrency(currency)">
                        <div
                          class="col"
                          [ngClass]="{'col-3 text-end': currency.click}"
                          >
                          <img
                            [hidden]="!currency.isOwner"
                            src="./assets/images/icon-user.png"
                            [ngClass]="{'img-box' : !ls.isDarkmode}"
                            alt=""
                            width="15"
                            height="15"
                          />
                          {{ currency.isoCode }}
                        </div>
                        <div
                          class="col"
                          style="position: relative;"
                          [ngClass]="{'col-3 text-end': currency.click}">
                          {{ currency.symbol }}
                          <img
                            *ngIf="currency == currentCurrency"
                            src="./assets/images/icon-done.png"
                            alt=""
                            height="25"
                            width="25"
                            style="position: absolute; right: 0">
                        </div>
                        <div
                          class="col text-end"
                          [hidden]="!currency.click">
                          <button
                            class="col btn btn-action select me-1"
                            (click)="selectCurrency(currency)">
                            <img
                              src="./assets/images/icon-done.png"
                              alt=""
                              class="w-100"
                              />
                          </button>
                          <button
                            class="col btn btn-action edit me-1"
                            (click)="setEdit(currency)">
                            <img
                              src="./assets/images/icon-edit.png"
                              alt=""
                              class="w-75"
                              />
                          </button>
                          <button
                            class="col btn btn-action delete"
                            (click)="setDelete(currency)">
                            <img
                              src="./assets/images/icon-delete.png"
                              alt=""
                              class="w-100"
                              />
                          </button>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-10 offset-1 text-end text-right mt-2">
                            <button
                                class="btn clear-outline bg-main-purple white-text"
                                data-bs-toggle="modal"
                                data-bs-target="#app-modal-add-currency"
                                (click)="showModalAddCurrency()"
                                >
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div class="col-12 text-center">
                            <button
                                class="btn btn-lg clear-outline bg-main-purple white-text"
                                data-bs-dismiss="modal"
                                (click)="confirmCurrency()"
                                >{{"buttons.button_save" | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-modal-add-currency
    [currency]="currencySelect"
    (onClose)="showModalAddCurrency()"
    >
</app-modal-add-currency>

<app-modal-delete
  modalId="ModalDeleteCurrency"
  (confirm)="confirmDelete($event)">
</app-modal-delete>

<!--

  <table
                                id="table-currencies"
                                class="table table-hover table-borderless rounded"
                                >
                                <thead class="">
                                    <th
                                        class="sticky-header"
                                        [ngClass]="{'bg-dark': ls.isDarkmode, 'bg-light': !ls.isDarkmode}"
                                        >{{ "currency_section.currency_iso_code" | translate }}
                                    </th>
                                    <th
                                        class="sticky-header"
                                        [ngClass]="{'bg-dark': ls.isDarkmode, 'bg-light': !ls.isDarkmode}"
                                        >{{ "currency_section.currency_symbol" | translate }}
                                    </th>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let currency of currencies"
                                        class="pointer"
                                        (click)="setCurrency(currency)"
                                        >
                                        <td
                                          [ngClass]="{
                                            'col-5': !currency.click,
                                            'col-4': currency.click
                                          }">
                                          <img
                                            [hidden]="!currency.isOwner"
                                            src="./assets/images/icon-user.png"
                                            alt=""
                                            width="15"
                                            height="15"
                                            />
                                          {{currency.isoCode}}
                                        </td>
                                        <td
                                          [ngClass]="{
                                            'col-5': !currency.click,
                                            'col-4': currency.click
                                          }">
                                          {{currency.symbol}}
                                        </td>
                                        <td class="col-2 text-center">
                                            <i
                                                class="fa fa-check"
                                                aria-hidden="true"
                                                *ngIf="currency == currentCurrency"
                                                >
                                            </i>
                                        </td>
                                        <td
                                          [hidden]="!currency.click"
                                          [ngClass]="{
                                            'col-2': currency.click
                                          }">
                                          <button>
                                            action
                                          </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

-->
